<template>
	<div class="main-top">
		<home-nav></home-nav>

		<!-- Trazilica banner -->
		<section id="uvjeti-banner" class="uvjeti-banner-area">
			<div class="overlay overlay-bg"></div>
			<div class="container">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 uvjeti-banner-content">
						<div class="row">
							<div class="col-12">
								<h1 class="text-center">Kontaktirajte nas</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="my-5">
			<div class="container">
				<div class="row">
					<div class="col-md-6">
						<h4 class="kontakt-title">Općeniti upiti</h4>
						<p class="kontakt-text">
							Ako imaš pitanja, prijedloga, kritika ili pohvala, piši nam na <a href="#" class="kontakt-a">upiti@figaro.hr</a>.
						</p>
						<h4 class="kontakt-title">
							Korisnička podrška
						</h4>
						<p class="kontakt-text">
							U slučaju bilo kakvih tehničkih poteškoća, piši nam na <a href="#" class="kontakt-a">podrska@figaro.hr</a>.
						</p>
					</div>
					<div class="col-md-6">
						<h4 class="kontakt-title">
							Za salone
						</h4>
						<p class="kontakt-text">
							Ako želiš staviti svoj salon na našu stranicu javi nam se na <a href="#" class="kontakt-a">saloni@figaro.hr</a>.
						</p>
						<h4 class="kontakt-title">
							Posao i karijera
						</h4>
						<p class="kontakt-text">
							Ako želiš surađivati s nama ili tražiš posao, piši nam na <a href="#" class="kontakt-a">karijera@figaro.hr</a>.
						</p>
					</div>
					<div class="col-12">
						<hr>
						<p class="text-center">
							FIGARO vl. Tino Botić<br>
							MBO: 98196057<br>
							IBAN: HR8924020061140397356
						</p>
					</div>
				</div>
			</div>
		</section>

		<home-footer></home-footer>
	</div>
</template>
<script>
	export default {
		name: 'home',
	}

</script>
